export default "/images/hu.png?863652aacfdb259466a14f7f424f1c37";